export enum AppURL {
  Login = '/login',
  Logout = '/logout',
  EnterpriseEmailLookup = '/login/enterprise',
  LoginResponse = '/login/response',
  Help = '/help',
  AccountLinkValidate = '/accountlinkvalidate',
  AccountLinkFailed = '/accountlinkfailed',
  ValidatedWrongAccount = '/validatedwrongaccount',
  LogOutValidatedWrongAccount = '/logoutvalidatewrongaccount',
  CantValidateExistingAccount = '/cantvalidateexistingaccount',
  AccountLinkFAQ = '/accountlinkfaq',
}
